import { render, staticRenderFns } from "./ModalEditarReceita.vue?vue&type=template&id=7ae3c2f8&"
import script from "./ModalEditarReceita.vue?vue&type=script&lang=js&"
export * from "./ModalEditarReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports